import apiClient from './client'

export type ExpenseCategory = 'fuel' | 'maintenance' | 'parking' | 'toll' | 'other'
export type ExpenseStatus = 'pending' | 'approved' | 'rejected'

export interface Expense {
  id: string
  driver_id: string
  tenant_id: string
  category: ExpenseCategory
  amount: string
  description?: string
  receipt_image_path?: string
  expense_date: string
  status: ExpenseStatus
  reviewer_note?: string
  created_at: string
  updated_at: string
  driver_name?: string
  driver_phone?: string
  tenant_name?: string
}

export interface ExpensesResponse {
  items: Expense[]
  total: number
  page: number
  limit: number
}

export const EXPENSE_CATEGORY_LABELS: Record<ExpenseCategory, string> = {
  fuel: '油錢',
  maintenance: '維修',
  parking: '停車費',
  toll: '過路費',
  other: '其他',
}

export const EXPENSE_STATUS_LABELS: Record<ExpenseStatus, string> = {
  pending: '待審核',
  approved: '已通過',
  rejected: '已駁回',
}

export const expenseApi = {
  // 司機新增支出（multipart/form-data）
  createExpense: async (data: {
    category: ExpenseCategory
    amount: number
    expense_date: string
    description?: string
    receipt_image?: File
  }) => {
    const formData = new FormData()
    formData.append('category', data.category)
    formData.append('amount', data.amount.toString())
    formData.append('expense_date', data.expense_date)
    if (data.description) formData.append('description', data.description)
    if (data.receipt_image) formData.append('receipt_image', data.receipt_image)

    const response = await apiClient.post<Expense>('/expenses', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return response.data
  },

  // 司機查看自己的支出
  getMyExpenses: async (params?: {
    page?: number
    limit?: number
    category?: ExpenseCategory
    status?: ExpenseStatus
  }) => {
    const p = new URLSearchParams()
    if (params?.page) p.append('page', params.page.toString())
    if (params?.limit) p.append('limit', params.limit.toString())
    if (params?.category) p.append('category', params.category)
    if (params?.status) p.append('status', params.status)
    const response = await apiClient.get<ExpensesResponse>(`/expenses/my?${p.toString()}`)
    return response.data
  },

  // 管理者查看所有支出
  getAllExpenses: async (params?: {
    page?: number
    limit?: number
    driver_id?: string
    category?: ExpenseCategory
    status?: ExpenseStatus
  }) => {
    const p = new URLSearchParams()
    if (params?.page) p.append('page', params.page.toString())
    if (params?.limit) p.append('limit', params.limit.toString())
    if (params?.driver_id) p.append('driver_id', params.driver_id)
    if (params?.category) p.append('category', params.category)
    if (params?.status) p.append('status', params.status)
    const response = await apiClient.get<ExpensesResponse>(`/expenses?${p.toString()}`)
    return response.data
  },

  // 管理者審核支出
  updateExpense: async (id: string, data: { status?: ExpenseStatus; reviewer_note?: string }) => {
    const response = await apiClient.patch<Expense>(`/expenses/${id}`, data)
    return response.data
  },

  // 刪除支出
  deleteExpense: async (id: string) => {
    await apiClient.delete(`/expenses/${id}`)
  },
}
